class BotoLogger {
  static error(message: unknown, ...optionalParams: unknown[]) {
    // eslint-disable-next-line no-console
    console.error(message, ...optionalParams)
  }

  static warn(message: unknown, ...optionalParams: unknown[]) {
    // eslint-disable-next-line no-console
    console.warn(message, ...optionalParams)
  }
}

export { BotoLogger }
